export const css = {
	root: '_23E_4mvo',
	disabled: '_1was6V4i',
	content: '_2HJ_Prer',
	header: '_2jjJSFR1',
	expandedContent: '_22dAYFMg',
	expanded: '_1J5cu5Nf',
	media: '_3CWhZEOj',
	visuallyHidden: '_2XOyts7a',
	' _key': 'certwise-theme/certwise/card/card'
};

export default css;
